// removed by extract-text-webpack-plugin
module.exports = {"CheckoutSummary":"-name__-loca-__1xBm4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Order/CheckoutSummary/CheckoutSummary.css
// module id = 201
// module chunks = 0